<template>
    <!--
            作者：kmdshop
            时间：2020-04-20
            描述：修改价格
        -->
    <el-dialog title="选择项目" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
               :close-on-press-escape="false" width="30%">
        <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table :data="tableData" size="small" border style="width: 100%" v-loading="loading" 
        @selection-change="handleSelectionChange">

          <el-table-column prop="name" label="服务项目"></el-table-column>
          <el-table-column type="selection" width="45" v-if="multi"></el-table-column>
          <el-table-column label="操作" width="80" v-else>
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="selectUser(scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[2, 10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import ProductApi from '@/api/product.js';
    export default {
        data() {
            return {
                 /*当前是第几页*/
                curPage: 1,
                /*一页多少条*/
                pageSize: 15,
                /*一共多少条数据*/
                totalDataNumber: 0,
                order_id: 0,
                loading: false,
                /*左边长度*/
                formLabelWidth: '100px',
                /*是否显示*/
                dialogVisible: true,
                /*表单*/
                order: {
                    update_price: 0,
                    update_express_price: 0.00,
                },
                tableData:[]
            };
        },
        props: {
            // 开启弹窗
            open_edit: Boolean,
            // 是否多选
            multi: {
            type: Boolean,
            default: () => {
                return false
            }
        },

        },
        created() {
            this.order_id = this.$route.query.order_id;
            this.getData();
        },
        methods: {
    
             /*选择第几页*/
            handleCurrentChange(val) {
            this.curPage = val;
            this.getTableList();
            },

            /*每页多少条*/
            handleSizeChange(val) {
            this.curPage = 1;
            this.pageSize = val;
            this.getTableList();
            },
//            获取数据
            getData(){
                let self = this;
                ProductApi.getService({
   
                }, true).then(data =>
                {
                    self.loading = false;
                    self.tableData = data.data.list.data;
                    self.totalDataNumber = data.data.list.total;
                }).catch(error =>
                {
                    self.loading = false;
                });
            },
             /*选择用户*/
            handleSelectionChange(e) {
                this.multipleSelection = e;
            },
             /*监听单选按钮选中事件*/
            selectUser(val) {
                this.multipleSelection = val;
                let self = this;
                    let params = this.multipleSelection;
                    self.loading = true;

                    ProductApi.addService({
                        order_id: self.order_id,
                        params: params,
                    }, true).then(data =>
                    {
                        self.loading = false;
                        self.$message({
                            message: '新增成功',
                            type: 'success'
                        });
                        self.dialogFormVisible(true);
                    }).catch(error =>
                    {
                        self.loading = false;
                    });
            },


            /*关闭弹窗*/
            dialogFormVisible() {
                this.$emit('close', {openDialog: false});
            }
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/order/order/dialog/service.vue